import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

import useLinkProps from '../../../../hooks/use-link-props';
import { useAppContext } from '../../../providers/app-context';
import getCategoryBySlug from '../utils/get-category-by-slug';

export type useBreadcrumbsType = (options: {
  groups: Array<TCategory>;
  selection: { category: TCategorySelection };
  brand?: TBrand;
  model?: TModel;
}) => Array<{ text: string } & ReturnType<ReturnType<typeof useLinkProps>>>;

const useBreadcrumbs: useBreadcrumbsType = ({
  selection,
  brand,
  model,
  groups,
}) => {
  const { t } = useTranslation();
  const {
    features: { isBrandEnabled },
  } = useAppContext();
  const getLink = useLinkProps();

  const breadcrumbs = useMemo(() => {
    const items = [];
    let query = {};

    if (selection) {
      const info = getCategoryBySlug(selection.category, groups);

      items.push({
        ...getLink('categories'),
        text: t('common:partscatalog'),
      });

      items.push({
        ...getLink('sub-categories', {
          category: selection.category.category,
        }),
        text: `${info.category} - ${info.subCategory}`,
      });

      //query = `?category=${selection.category.category}&subCategory=${selection.category.subCategory}`;
      query = {
        category: selection.category.category,
        subCategory: selection.category.subCategory,
      };
    }

    if (!isBrandEnabled && brand) {
      items.push({
        ...(selection ? getLink('brands-with-part', query) : getLink('brands')),
        text: t('common:brand.other'),
      });
    }

    if (brand && model) {
      items.push({
        ...(selection
          ? getLink('models-with-part', {
              brand: brand.slug,
              ...query,
            })
          : getLink('models', {
              brand: brand.slug,
            })),
        text: t('common:model.breadrumb', { brand: brand.name }),
      });
    }

    return items;
  }, [selection, brand, model, getLink, groups, t, isBrandEnabled]);

  return breadcrumbs;
};

export default useBreadcrumbs;
